import type { BlockResult } from '@/types/blocker'
import type { BlockCondition } from '@/types/blocker'
import type { StageWithUnderscores } from '@/types/journey'

import type { LevelUiStatus } from '../constants/status'

export function isStageUnlocked(
  stage: StageWithUnderscores,
  checkBlockCondition: (condition: BlockCondition) => BlockResult
): boolean {
  return stage._levels.some(
    level => checkBlockCondition(level._blockCondition).unlocked
  )
}

type PhaseUiStatusInput = {
  stage: StageWithUnderscores
  previousStage?: StageWithUnderscores
  isStageUnlocked: boolean
  currentLevelUid?: string
}

export function getPhaseUiStatus({
  stage,
  previousStage,
  isStageUnlocked: unlocked,
  currentLevelUid
}: PhaseUiStatusInput): LevelUiStatus {
  if (stage._progress.finished) return 'success'

  if (previousStage && !previousStage._progress.finished) return 'locked'
  if (!unlocked) return 'locked'

  if ((stage._progress.totalFinishedCount ?? 0) > 0) return 'progress'

  /* Fase que contém o nível atual da jornada está em andamento mesmo com zero
     níveis concluídos — o participante já começou a trabalhar nela. */
  if (
    currentLevelUid &&
    stage._levels.some(level => level.uid === currentLevelUid)
  ) {
    return 'progress'
  }

  return 'available'
}
